// Features.jsx - > Our Core Values
import React from "react";
import {
  Container,
  Grid,
  Typography,
  Box,
  // Card,
  // CardContent,
} from "@mui/material";
// import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
// import HotelIcon from "@mui/icons-material/Apartment";
// import WifiIcon from "@mui/icons-material/Wifi";
// import FastfoodIcon from "@mui/icons-material/Fastfood";
import "./Style.css";
import CoreImg from '../assets/CoreValues.jpeg';

function FeaturesSection() {
  return (
    <section className="feature-section-container" id="Features">
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          {/* Left Section (Image & Reviews) */}
          <Grid item xs={12} md={6} className="feature-section-image-container">
            <Box className="feature-image-box">
              <img
                src={CoreImg}
                alt="Contact"
                className="core-values-image"
              />
            </Box>
          </Grid>

          {/* Right Section (Text & Features) */}
          <Grid item xs={12} md={6}>
            <Typography variant="h4" className="feature-section-title">
              <b>Our Core Values</b>
            </Typography>

            <div className="about-us-text">
              <h3>Vision</h3>
              <p>
               To inspire travelers worldwide by delivering extraordinary journeys, combining innovation, expertise, and sustainability, while maintaining the highest global standards in travel services.
              </p>

              <h3>Mission</h3>
              <p>
                To provide seamless, personalized, and stress-free travel experiences that empower every traveler to explore the world with confidence and joy.
              </p>

              <h3>Goals</h3>
              <p>
                To revolutionize travel planning with next-generation technology, expert service, and curated itineraries that transform travel dreams into reality.
              </p>

              <h3>Objectives</h3>
              <p>
                To continuously enhance our global presence, strengthen customer trust, and deliver premium, tech-enabled travel experiences supported by 24/7 assistance and multilingual expertise.
              </p>
            </div>
           
          </Grid>
        </Grid>
      </Container>
    </section>
  );
}

export default FeaturesSection;
